// @flow
import isEmptyObject from 'is-empty-object';
import type { ComponentType } from 'react';
import React from 'react';

import type { ERROR_TYPE } from '../../types/common';
import styles from './inlineError.css';


type InlineErrorsPropTypes = {
  objectError?: ERROR_TYPE,
  ErrorComponent?: ComponentType<*>,
};

// TODO: Review this props
type DefaultErrorPropTypes = {
  // object_id?: number,
  statusCode: number,
  message: string,
  // data?: Object,
  // retryAction?: Object
};

let DefaultError = ({
  statusCode,
  message,
}: DefaultErrorPropTypes) => (
  <div className={styles.error}>
    { `${message}` }
  </div>
);

const InlineError = ({
  objectError,
  ErrorComponent,
}: InlineErrorsPropTypes) => {
  if (typeof ErrorComponent !== 'undefined') {
    DefaultError = ErrorComponent;
  }
  if (objectError != null && !isEmptyObject(objectError)) {
    return <DefaultError {...(objectError || {})} />;
  }
  return null;
};

export default InlineError;



// WEBPACK FOOTER //
// ./src/scripts/components/InlineError/index.jsx